import React from 'react';
import specialIns from '../../assets/icons/new_icon/specialIns.svg';

const SpecialInstruction = () => {
  return (
    <div>
      {' '}
      <div className='d-flex m-auto flex-column justify-content-center '>
        <div className='m-auto mb-2'>
          {' '}
          <img src={specialIns} />
        </div>
        <p className='specialIns mb-0'>
          Special Instructions Not Provided Yet!
        </p>{' '}
      </div>
    </div>
  );
};

export default SpecialInstruction;
